import { usePullToRefresh } from '@/gestures';
import { cn } from '@/lib/utils';
import { useT } from '@/str';

export function usePullRefresh(onRefresh: () => void | Promise<void>) {
  const t = useT();
  const { ref, pillRef, refreshing } = usePullToRefresh(onRefresh);

  const pill = (
    <div
      className="pointer-events-none fixed inset-x-0 top-[calc((56px+env(safe-area-inset-top,0px))/var(--zoom,1))] z-8 flex justify-center opacity-0"
      ref={pillRef}
      aria-hidden
    >
      <span className="bg-card border-border-strong text-muted-foreground flex items-center gap-2.25 rounded-full border px-3.5 py-1.75 text-xs font-extrabold tracking-[0.12em] uppercase">
        <span
          className={cn(
            'border-accent-ink block size-2.75 flex-none rounded-full border-2 border-t-transparent',
            refreshing && 'animate-spin',
          )}
        />
        {t.ptr}
      </span>
    </div>
  );

  return { ref, pill };
}
